var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGanchillo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 91,
    viewBox: "0 0 50 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89961 90.8638C2.4555 91.2669 0.826091 90.8638 0.0113862 88.4455C-0.803318 86.0272 42.376 9.44741 41.5613 6.62606C40.7466 3.8047 37.0805 9.85046 35.451 7.43216C33.8216 5.01386 37.8721 0.703712 41.5613 0.177232C45.7979 -0.427363 51.3378 0.177235 49.7084 7.43216C48.079 14.6871 7.34373 90.4608 4.89961 90.8638Z",
    fill: "#5B3B52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanchillo);
export default __webpack_public_path__ + "static/media/ganchillo.533bfcf46c7a18dca2cb5ff6c401dc09.svg";
export { ForwardRef as ReactComponent };